import { ActionIcon } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IIssueApi } from "@schemas/issueSchema";
import { IconArchive } from "@tabler/icons-react";
import React, { useState } from "react";
import { usePutProjectByProjectIdIssueArchiveMutation } from "../../../../../../openapi";
import { ConfirmAbortModal } from "../../../../../components/ConfirmAbortModal/ConfirmAbortModal";

const lowerFirst = (value: string): string => value.charAt(0).toLocaleLowerCase() + value.slice(1);

const ConnectedTaskDeleteCell: React.FC<{
  task: IIssueApi;
  projectId: string;
  taskDefiniteLabel?: string;
  controlSize?: number;
  iconSize?: number;
}> = ({ task, projectId, taskDefiniteLabel = "Aksjonen", controlSize = 24, iconSize = 16 }) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [archiveIssue] = usePutProjectByProjectIdIssueArchiveMutation();
  const taskDefiniteLower = lowerFirst(taskDefiniteLabel);

  const archive = async () => {
    await archiveIssue({
      projectId,
      body: {
        issueId: task._id,
      },
    }).unwrap();

    setOpenConfirm(false);
    notifications.show({
      title: "Arkivert",
      message: `${taskDefiniteLabel} er nå arkivert.`,
      color: "green",
      icon: <IconArchive size={iconSize} />,
    });
  };

  return (
    <>
      <div className="grid-cell-center-fix d-flex align-items-center h-100">
        <ActionIcon
          aria-label={`Arkiver ${taskDefiniteLower}`}
          color="red"
          size={controlSize}
          variant="subtle"
          onClick={() => setOpenConfirm(true)}
        >
          <IconArchive size={iconSize} />
        </ActionIcon>
      </div>
      <ConfirmAbortModal
        isOpen={openConfirm}
        onCancel={() => setOpenConfirm(false)}
        onConfirm={archive}
        customHeader="Bekreft arkivering"
        customText={`Er du sikker på at du vil arkivere ${taskDefiniteLower}?`}
        customButtonText="Bekreft"
        customButtonIcon={<IconArchive size={iconSize} />}
      />
    </>
  );
};

export default ConnectedTaskDeleteCell;
